module.exports = __webpack_public_path__ + "img/logo-meghpakhi-25periye.6097ca5f.png";